import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { useState, useRef,useEffect } from "react"
import { useToasts } from "react-toast-notifications";
import { getDiscountPrice } from "../../../helpers/product";
import { multilanguage } from "redux-multilanguage";
//import { useSelector } from "react-redux";
import { transformFilename } from "../../../helpers/imgfilename";

const MenuCart = ({ cartData, currency, deleteFromCart, strings,currentLanguageCode }) => {
  let cartTotalPrice = 0;
  const websize="-websize"
  const { addToast } = useToasts();
  const cartRef=useRef(null);
  const [inDiv, setInDiv] = useState(false);

  const handleClick = e => {
    const cartContent = document.querySelector(
      "#cart-box"
    );
    cartContent.classList.toggle("active");
    setInDiv(false);
  }


  useEffect(() => {
    let timer=null;
    let cartContent=null;
    const handleMoveOutside= (event) => {
      if (cartRef.current && !cartRef.current.contains(event.target)) {
         cartContent = document.querySelector(
          ".shopping-cart-content"
        );
        clearTimeout(timer);
        timer= setTimeout(function() {
          if (cartContent) {
           cartContent.classList.remove("active");
           setInDiv(false);
          }
        },300);        
      }
      else clearTimeout(timer);
    };
    if (inDiv===true) {
      document.addEventListener('mousemove', handleMoveOutside);
      return () => {
        document.removeEventListener('mousemove',handleMoveOutside);
      };       
    }
  },[inDiv]);

  useEffect(() => {  
    const handleMoveInside = (event) => {
      if (cartRef.current && cartRef.current.contains(event.target)) {
          setInDiv(true);
        }
    };

        document.addEventListener('mousemove', handleMoveInside);
        return () => {
          document.removeEventListener('mousemove',handleMoveInside);
        };       
  },[]);
 
  
  return (
    <div ref={cartRef} id="cart-box" className="shopping-cart-content">
      {cartData && cartData.length > 0 ? (
        <Fragment>
          <ul>
            {cartData.map((single, key) => {
              const discountedPrice = getDiscountPrice(
                single.price,
                single.discount
              );
              const finalProductPrice = (
                single.price * currency.currencyRate
              ).toFixed(1);
              const finalDiscountedPrice = (
                discountedPrice * currency.currencyRate
              ).toFixed(1);

              discountedPrice != null
                ? (cartTotalPrice += finalDiscountedPrice * single.quantity)
                : (cartTotalPrice += finalProductPrice * single.quantity);

              return (
                <li className="single-shopping-cart" key={key}>
                  <div className="shopping-cart-img">
                    <Link to={process.env.PUBLIC_URL + "/product/" + single.id}>
                      <img
                        alt=""
                        src={process.env.REACT_APP_MEDIAURL + "/"+ transformFilename(single.image[0], websize)}
                        className="img-fluid"
                        onError={(e) =>{
                          e.target.src='/assets/img//no-image.png'
                        }}
                      />
                    </Link>
                  </div>
                  <div className="shopping-cart-title">
                    <h4>
                      <Link
                        to={process.env.PUBLIC_URL + "/product/" + single.id}
                      >
                        {" "}
                        {currentLanguageCode==='zh'?single.name:single.nameen}{" "}
                      </Link>
                    </h4>
                    <h6>{strings["qty"]}{" "}: {" "}
                    {single.quantity}
                                    {
                                    single.unit[0]?.id===single.id && currentLanguageCode==='zh' ?
                                    (<span className="perunit">{single.unit[0].name}</span> )
                                    :
                                    single.unit[0]?.id===single.id && currentLanguageCode==='en' ? 
                                    (<span className="perunit">{single.unit[0].namee}</span>)
                                    : 
                                    single.unit[1]?.id===single.id && currentLanguageCode==='zh' ?
                                    (<span className="perunit">{single.unit[1].name}</span> )
                                    :
                                    single.unit[1]?.id===single.id && currentLanguageCode==='en' ? 
                                    (<span className="perunit">{single.unit[1].namee}</span>)
                                    : 
                                    single.unit[2]?.id===single.id && currentLanguageCode==='zh' ?
                                    (<span className="perunit">{single.unit[2].name}</span> )
                                    :
                                    <span className="perunit">{single.unit[0].namee}</span>                                      
                                    }
                    
                    </h6>
                    <span>
                      {discountedPrice !== null
                        ? currency.currencySymbol + parseFloat(finalDiscountedPrice).toLocaleString(undefined, {minimumFractionDigits: 2}) 
                        : currency.currencySymbol + parseFloat(finalProductPrice).toLocaleString(undefined, {minimumFractionDigits: 2})}
                    </span>
                    {single.selectedProductColor &&
                    single.selectedProductSize ? (
                      <div className="cart-item-variation">
                        <span>Color: {single.selectedProductColor}</span>
                        <span>Size: {single.selectedProductSize}</span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="shopping-cart-delete">
                    <button onClick={() => deleteFromCart(single, addToast)}>
                      <i className="fa fa-times-circle" />
                    </button>
                  </div>
                </li>
              );
            })}
          </ul>
          <div className="shopping-cart-total">
            <h4>
              {strings["cart_total"]} :{" "}
              <span className="shop-total">
                {currency.currencySymbol + parseFloat(cartTotalPrice).toLocaleString(undefined, {minimumFractionDigits: 2})}
              </span>
            </h4>
          </div>
          <div className="shopping-cart-btn btn-hover text-center">
            <Link className="default-btn" to={process.env.PUBLIC_URL + "/cart"}>
              {strings["view_cart"]}
            </Link>
            <Link
              className="default-btn"
              to={process.env.PUBLIC_URL + "/checkout"}
            >
              {strings["checkout"]}
            </Link>
          </div>
        </Fragment>
      ) : (
        <div className="item-empty-area text-center">
         <div className="item-empty-area__icon mb-30">
          <i className="pe-7s-cart"></i>
        </div>      
        <div className="item-empty-area__text">        
        {strings["no_items_added_to_cart"]}
        <br />{" "}
        <Link to={process.env.PUBLIC_URL + "/shop"}
          onClick={e => handleClick(e)}
        >
        {strings["continue_shopping"]}
       </Link>
       </div>
       </div>
      )}
    </div>
  );
};

MenuCart.propTypes = {
  cartData: PropTypes.array,
  currency: PropTypes.object,
  deleteFromCart: PropTypes.func,
  strings: PropTypes.object
};

export default multilanguage(MenuCart);
